import React from 'react';
import Button from '../../../../components/Button';
import Anchor from '../../../../components/link/Anchor';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { SEARCH_WORD_EDIT_URL_PATH } from '../../../../constants/service/common/urlConstants';
import { reDirectPage, setDetailPageUrl } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';

/**
 *  검색 키워드 리스트 컬럼
 */
export const columns = (data) => {
  const { sortOption } = data;

  return [
    {
      title: '수정',
      dataIndex: 'edit',
      render: (value, record) => (
        <Button
          isRadius
          color="primary"
          onClick={() =>
            reDirectPage({
              path: setDetailPageUrl(SEARCH_WORD_EDIT_URL_PATH, record.id),
            })
          }
          text="편집"
        />
      ),
    },
    {
      title: 'ID',
      dataIndex: 'id',
      render: (value) => (
        <Anchor
          isUnderLine
          color="primary"
          onClick={() =>
            reDirectPage({
              path: setDetailPageUrl(SEARCH_WORD_EDIT_URL_PATH, value),
            })
          }
          text={value}
        />
      ),
    },
    {
      title: '키워드',
      dataIndex: 'word',
      render: (value) => value,
    },
    {
      title: '검색 횟수',
      dataIndex: 'count',
      sorter: true,
      sortOrder: sortOption['count'],
      render: (value) => value,
    },
    {
      title: '생성일',
      dataIndex: 'createDate',
      sorter: true,
      sortOrder: sortOption['createDate'],
      render: (value) => setDateFormat(value, DATE_FORMAT.YMD_KOREAN_FORMAT),
    },
  ];
};
